import Vue from 'vue'
import { format } from 'date-fns'

Vue.filter('formatDate', date => {
    if (!date) return 'Never'
    else return format(parseInt(date), 'yyyy-MM-dd HH:mm:ss')
})